import { Sorteable } from "./sorteable";

export class Pageable {
    sort: Sorteable = new Sorteable();
    // The number of elements in the page
    pageSize: number = 0;
    // The total number of pages
    totalPages: number = 0;
    // The current page number
    pageNumber: number = 0;

    paged: boolean = true;
    unpaged: boolean = false;
}
